// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/yves_default." + ({"38":"paypal-buttons","638":"script-loader"}[chunkId] || chunkId) + ".js";
};